import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiDatabaseRefresh } from '@lumapps/lumx/icons';
import { ApplicationsSideNavigation } from '@lumapps/providers-applications/components/ApplicationsSideNavigation';
import { PROVISIONING_DASHBOARD } from '@lumapps/providers-dashboard-admin/keys';
import { provisioningDashboardRoute } from '@lumapps/providers-dashboard-admin/routes';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { PROVIDERS } from '../../keys';
import { identityProviderRoute } from '../../routes';

export interface ProvidersSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const ProvidersSideNavigation: React.FC<ProvidersSideNavigationProps> = ({ isAllowed, ...restOfProps }) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(GLOBAL.PROVIDERS)}
            icon={mdiDatabaseRefresh}
            id="providers"
        >
            <SideNavigationItem
                label={translateKey(PROVISIONING_DASHBOARD.DASHBOARD)}
                route={provisioningDashboardRoute}
            />
            <SideNavigationItem label={translateKey(PROVIDERS.IDP)} route={identityProviderRoute} />

            <ApplicationsSideNavigation />
        </SideNavigationItem>
    );
};

ProvidersSideNavigation.displayName = 'SideNavigationItem';

export { ProvidersSideNavigation };
